import React, { useState, useEffect } from 'react';
import './header.scss';
import { useStaticQuery, graphql } from "gatsby";
import FontSize from '../../atoms/font-size/fontSize';
import Login from '../../atoms/login/login';
import useScrollDetect from '../../../shared/hooks/useScrollDetect';
import ButtonBurger from '../../atoms/button-burger/buttonBurger';
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import GlobalContext from '../../../contexts/globalContext';
import { LoginGigyaInterface } from '../../../shared/interfaces/LoginGigyaInterface';

interface HeaderInterface {
   isDark: boolean;
   isMenuActive: boolean;
   isSearcherActive: boolean;
   isNotRoot?: boolean;
   lastDirection: number;
   hideHeaderDesktop: boolean;
   hideHeaderMobile: boolean;
   scrollActive: { get: boolean, set: (_var:boolean) => void };
   setMenuActive: ( isMenuActive: boolean ) => void;
   setSearcherActive: ( isSearcherActive: boolean ) => void;
   actionTheme: () => void;
}

const Header = ( props: HeaderInterface ) => {

   const data = useStaticQuery(graphql`
      query HEADER_CONTENT {
         allContentfulMenuLoggin(filter: {titulo: {eq: "Menu login comfama.com"}}) {
            nodes {
               inicioSesion
               logoGray {
                  title
                  file {
                     url
                     fileName
                  }
               }
               logoMagenta {
                  title
                  file {
                     url
                     fileName
                  }
               }
               logoWithe {
                  title
                  file {
                     url
                     fileName
                  }
               }
            }
         }
      }
   `)

   const { inicioSesion, logoMagenta, logoWithe } = data.allContentfulMenuLoggin.nodes[0];
   const [showFontSize, setShowFontSize] = useState(false);
   const {refElement, isScrollActive} = useScrollDetect();
   const { isBrowser, window } = useBrowserMode();
   
   const isModeOpen = props.isMenuActive || props.isSearcherActive || props.isNotRoot || isScrollActive;
   const modeShadow = (!props.isMenuActive && props.isNotRoot && !props.isSearcherActive) || (isScrollActive && !props.isMenuActive && !props.isSearcherActive);
   

   const openMenu = () => {
      toogleFreeze(true);
      props.setMenuActive(true)
      props.setSearcherActive(false)
	}
	const closeMenu = () => {
		toogleFreeze(false);
      props.setMenuActive(false)
   }
   
   const handleSearcher = () => {
      toogleFreeze(!props.isSearcherActive);
      props.setSearcherActive(!props.isSearcherActive)
      props.isMenuActive && props.setMenuActive(false)
   }
   
   const toogleFreeze = ( isToggle:boolean ) => {
		isToggle ? document.body.classList.add('freeze-page') : document.body.classList.remove('freeze-page') 
   }
   
   useEffect( ()=> {
      props.scrollActive.set(isScrollActive);
   }, [isScrollActive] )

   const renderBurguerButton = () => {
      const burguerButton = <ButtonBurger 
         isMenuActive={ props.isMenuActive }
         isSearcherActive={ props.isSearcherActive }
         closeMenu={ closeMenu }
         openMenu={ openMenu }
         isNotRoot={ isModeOpen }
         lastDirection={ props.lastDirection }
         hideHeaderDesktop={ props.hideHeaderDesktop }
      /> 

      if (isBrowser && window.screen.width < 720 && props.isSearcherActive) return <React.Fragment />

      return burguerButton;
   }

   const renderLoginButton = ( { login, logout, updateProfile, gigyaAccount }: LoginGigyaInterface ) => {
      const loginButton = <Login 
         isMenuActive={isModeOpen}
         title={inicioSesion}
         login={login}
         logout={logout}
         updateProfile={updateProfile}
         gigyaAccount={gigyaAccount}
      />

      if ( isBrowser && window.screen.width < 720 && props.isSearcherActive) return <React.Fragment />

      return loginButton;
   }

   return (
      <GlobalContext.Consumer>
         {data => (
            <header 
               ref={refElement} 
               className={ 
                  `m-header${ isModeOpen ? ' m-header-open' : '' }` + 
                  `${ props.isSearcherActive || props.isMenuActive ? ' m-header-open__searcher' : ''}` +
                  `${ modeShadow ? ' m-header-shadow' : ''}` +
                  `${ props.hideHeaderMobile && isScrollActive && props.lastDirection > 0 ? ' m-header__hide-mobile' : '' }` +
                  `${ props.hideHeaderDesktop && !props.isMenuActive && !props.isSearcherActive /* && isScrollActive */ && props.lastDirection > 0 ? ' m-header__hide-desktop' : '' }`
               } 
            >
               {
                  renderBurguerButton()
               }
               <div className={`m-header__container ${props.isSearcherActive && 'm-header__container--search'}`} ref={refElement} >
                  <div className='m-header__cover' >
                     <a href='/' rel="nofollow noreferrer" className='gtmMenuTransLogoComfama' >
                        <img 
                           className='m-header__cover__img gtmMenuTransLogoComfama'
                           src={ (isModeOpen ? logoMagenta : logoWithe ).file.url} 
                           alt={ (isModeOpen ? logoMagenta : logoWithe ).title} 
                        />
                     </a>
                  </div>
                  <div  className='m-header__container-action' >
                     <i 
                        className='hide-mobile icon icon-font-change-2 gtmMenuTransTamanoLetra'
                        onClick={() => setShowFontSize(!showFontSize) }
                     />
                     <div  
                        className={`float-box ${showFontSize ? 'show': '' }`}
                     > 
                        {showFontSize && <FontSize setShowFontSize={setShowFontSize} />}
                     </div>
                     <i 
                        className={`hide-mobile icon ${ props.isDark ? 'icon-sun gtmMenuTransTonalidadFondoBlanco' : 'icon-moon gtmMenuTransTonalidadFondoNegro' }`} 
                        onClick={props.actionTheme}
                     />
                     <i className={`icon ${props.isSearcherActive ? 'icon-close' : 'icon-search'} gtmMenuTransBuscar`} onClick={() => handleSearcher()} />
                     {
                        renderLoginButton( data.gigyaContext )
                     }
                  </div>
               </div>
            </header>
         )} 
      </GlobalContext.Consumer>
   )
}

export default Header;
